import React, { useState } from "react";
import MyContext from "./MyContext";

function MyProvider({ children }) {
  const [count, setCount] = useState(0);

  //Authentication
  const [headers, setHeaders] = useState(null);
  const [requestAuthentication, setRequestAuthentication] = useState(false);

  //Dev or Production
  const [dev, setDev] = useState(false);

  //Data
  const [data, setData] = useState({
    leadId: "",
    firstName: "",
    lastName: "",
    idNumber: "",
    mobile: "",
    email: "",
    message: "",
    sourceRef: "",
  });

  //Laminin
  const [lamininSubmitted, setLamininSubmitted] = useState(false);
  const [lamininSent, setLamininSent] = useState(false);
  const [lamininError, setLamininError] = useState(false);
  const [lamininResponse, setLamininResponse] = useState({});

  //Forms
  const [personalInfoCaptured, setPersonalInfoCaptured] = useState(false);

  return (
    <MyContext.Provider
      value={{
        //Counter
        count,
        setCount,

        //Authentication
        headers,
        setHeaders,
        requestAuthentication,
        setRequestAuthentication,

        //Dev or Production
        dev,
        setDev,

        //Data
        data,
        setData,

        //Laminin
        lamininSubmitted,
        setLamininSubmitted,
        lamininSent,
        setLamininSent,
        lamininError,
        setLamininError,
        lamininResponse,
        setLamininResponse,

        //Forms
        personalInfoCaptured,
        setPersonalInfoCaptured,
      }}
    >
      {children}
    </MyContext.Provider>
  );
}

export default MyProvider;
